import { useEffect, useState } from "react"
import { Portal, PortalContainer } from "../main/Portal"
import { Padder, SimpleButton, SimpleInputWithLabel } from "./SimpleElements"
import { SimpleScreenBottom, SimpleScreenTop } from "./SimpleScreenBottom"
import { useAddNewOrganization, useOrganization } from "../../../biz/hooks/entities/useOrganization"
import { LoginLogo } from "./Login"
import { useUser } from "../../../biz/hooks/entities/useUser"
import { useDialogs } from "./MesssageBoxes"
import { useNavigate } from "react-router-dom"
import { Config } from "../../../biz/data/Config"
import { useTranslation } from "react-i18next"

export const MAX_COMPANY_LETTERS = 25
export const CreateOrganization = () => {

    const user = useUser();
    const nav = useNavigate();

    const { t } = useTranslation();

    const dialogs = useDialogs();
    const addNewOrganizationOps = useAddNewOrganization();
    const orgs = useOrganization();
    const [creating, setCreating] = useState<boolean>(false);
    const onCreate = async () => {
        setCreating(true);
        const res = await user.createNewOrganization(addNewOrganizationOps.organizationName);
        if (!res?.success) {
            dialogs.showWarning(t("couldNotCreateCompany"), res.message);
        } else {
            await user.loadUser();
            await orgs.loadOrganizations();
            nav(Config.routes.simple_profile);

            addNewOrganizationOps.endAdd();
        }
        setCreating(false);
    }

    const [isVisible, setIsVisible] = useState<boolean>(false);
    useEffect(() => {
        const hasOrganizations = (user?.organizationRoles?.length ?? 0) > 1;
        setIsVisible(hasOrganizations === false || addNewOrganizationOps.isAdding === true);

    }, [, user]);

    const [warningIsVisible, setWarningIsVisible] = useState<boolean>(false);



    return (
        <Portal visible={isVisible}>
            <div className="login-start-container">
                <SimpleScreenTop />
                <form>
                    <Padder heightPx={64} />
                    <div className="login-start-container2">

                        {addNewOrganizationOps.viewState === "createaccount" && (
                            <div className="login-start-box" style={{ marginBottom: "380px" }}>
                                <div className="login-box" style={{ borderRadius: "16px" }}>
                                    <h1>
                                        {t("emailConfirmed")}
                                    </h1>
                                    <Padder heightPx={32} />
                                    <div className="your-email">
                                        {user?.email}
                                    </div>
                                    <Padder heightPx={8} />
                                    <div className="is-confirmed">
                                        {t("isNowConfirmedAndYouAreWelcomeToYourAccountWithUsAtOhGarden")}
                                    </div>

                                    <hr className="separator" />

                                    <h2>
                                        {t("profilename")}
                                    </h2>
                                    <Padder heightPx={8} />
                                    <div className="text-para-small">
                                        {t("organizationNameTagline")}
                                    </div>
                                    <Padder heightPx={32} />

                                    <SimpleInputWithLabel
                                        elementId="organizationname"
                                        label={""}
                                        value={addNewOrganizationOps.organizationName}
                                        placeholder={t("profilename")}
                                        onChange={e => {
                                            addNewOrganizationOps.setOrganizationName(e);
                                            setWarningIsVisible(e.length <= 0 || e?.length > MAX_COMPANY_LETTERS);
                                        }}
                                        disabled={creating}
                                        autoComplete="off"
                                    />

                                    {warningIsVisible && (
                                        <>
                                            <div className="input-warning">
                                                <div className="input-warning-oh">Oh!</div>
                                                <div className="input-warning-text">
                                                    {t("createOrganizationWarning", { count: MAX_COMPANY_LETTERS })}
                                                </div>
                                            </div>
                                            <Padder heightPx={16} />
                                        </>
                                    )}


                                    <SimpleButton
                                        type="primarygreen"
                                        shape="bigpill"
                                        icon="check"
                                        onClick={onCreate}
                                        label={t("confirm")}
                                        disabled={!(addNewOrganizationOps.organizationName?.length > 3) || creating}
                                        fullWidth={true}
                                        iconRight={true}
                                    />


                                </div>

                                <div className="image-box">
                                    <img src="./gfx/login-phones.png" style={{ width: "641px" }} />
                                </div>
                            </div>
                        )}

                    </div>

                </form>
                <SimpleScreenBottom />

            </div>
        </Portal>
    )
}


